/**
 * Vocabulario de ambiente do banco alvo.
 * Fonte: spec/00-CONSTITUTION.md C2 e spec/04-ARCHITECTURE.md §4.
 */
export const ENVIRONMENTS = ['local', 'staging', 'production'] as const;

export type Environment = (typeof ENVIRONMENTS)[number];

export function isEnvironment(value: unknown): value is Environment {
  return typeof value === 'string' && (ENVIRONMENTS as readonly string[]).includes(value);
}

export const ENVIRONMENT_LABELS: Record<Environment, string> = {
  local: 'Local',
  staging: 'Staging',
  production: 'Produção',
};

/** Token que o operador digita quando `requires.typedToken === 'environment'`. */
export const ENVIRONMENT_TOKENS: Record<Environment, string> = {
  local: 'local',
  staging: 'staging',
  production: 'production',
};

/** Retencao default de backups por ambiente (spec/11-BACKUP-RESTORE.md §7). */
export const BACKUP_RETENTION_DAYS: Record<Environment, number> = {
  local: 7,
  staging: 14,
  production: 30,
};
